/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-warehouse',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '客户等级',
            value: 'customerLevel',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_CUSTOMER_LEVEL',
            span: 5
        },
        {
            name: '行业大类',
            value: 'industryCategoryList',
            type: 'select',
            options: [],
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '行业类型',
            value: 'industryTypeName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'industryTypeName', 'value': '行业类型名称' },
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' }
            ],
            tableConfig: [
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' },
                { 'prop': 'industryTypeName', 'value': '行业类型名称', 'displayName': 'industryTypeName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/industry/info/page`,
            method: 'post',
            cbParams: ['industryTypeCode', 'industryTypeName']
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName']
        }
    ],
    columns: [
        {
            label: '客户仓库名称',
            prop: 'warehouseName',
            width: 120
        },
        {
            label: '客户行业大类',
            prop: 'customerIndustryCategory',
            width: 120,
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYS_SUPPLIER_INDUSTRY'
        },
        {
            label: '客户行业类型',
            prop: 'customerIndustryTypeName',
            width: 120
        },
        {
            label: '客户等级',
            prop: 'customerLevel',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '客户系',
            width: 150,
            prop: 'customerSeriesName'
        },
        {
            label: '客户',
            width: 150,
            prop: 'customerName'
        },
        {
            label: '地级市',
            width: 150,
            prop: 'city'
        },
        {
            label: '分公司',
            width: 150,
            prop: 'branchCompany'
        },
        {
            label: '所属部门',
            width: 150,
            prop: 'department'
        },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
